import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { cloneDeep } from 'lodash';
import { ICloseReturnType, PlaceholderChildComponent } from '../../../layout/classes/placeholder-child-component.abstract';
import { modalResponse } from '../../../layout/constants/modal-responses.enum';
import { DynamicFormModalResponse } from '../../../shared/dynamic-form/classes/dynamic-form-modal-response.class';

@Component({
  selector: 'gen-add-rich-notes',
  templateUrl: './add-rich-notes.component.html',
  styleUrls: ['./add-rich-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddRichNotesComponent extends PlaceholderChildComponent implements OnInit {
  private submitted: boolean;
  private valid: any;
  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  beforeClose(_modalResponse: modalResponse) {
    if (_modalResponse !== modalResponse.approve) {
      return;
    }
    return { value: this.payload.notes};
  }

}
